function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#636363;}.b{fill:#494949;}.c{fill:#52c41a;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M6.54,227.68,256,339.23,505.46,227.68a11.06,11.06,0,0,0,0-20.19L260.52,98a11.12,11.12,0,0,0-9,0L6.54,207.49A11.06,11.06,0,0,0,6.54,227.68Z",
  transform: "translate(0 -97)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M505.46,207.49,260.52,98a11.1,11.1,0,0,0-9,0l-18.16,8.12L460.13,207.5a11.05,11.05,0,0,1,0,20.18l-23.83,10.66-1.25-.92c-78.77-58.4-174.39-61.73-178.42-61.85l-.62,0-.62,0c-4,.12-99.65,3.45-178.42,61.85L68,244.05v11.12l188,84.06,188-84.06,61.46-27.49A11.06,11.06,0,0,0,505.46,207.49Z",
  transform: "translate(0 -97)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M261,414c46.14-23.71,123-31.19,150.64-33.18a11.05,11.05,0,0,0,10.26-11V255.18C347.78,200.26,256,197.68,256,197.68s-91.79,2.58-165.87,57.5V369.75a11,11,0,0,0,10.26,11c27.61,2,104.5,9.47,150.63,33.18A10.91,10.91,0,0,0,261,414Z",
  transform: "translate(0 -97)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M388.7,340a22.11,22.11,0,0,1-19.16,21.92c-32.57,4.37-73.85,12.34-104,26.58a22.22,22.22,0,0,1-19,0c-57.77-27.28-156.37-31.57-156.37-31.57v12.82a11.05,11.05,0,0,0,10.26,11c27.61,2,104.5,9.46,150.63,33.17a10.91,10.91,0,0,0,10,0c46.14-23.71,123-31.18,150.64-33.17a11.05,11.05,0,0,0,10.26-11V255.18a260.09,260.09,0,0,0-33.17-20.82V340Z",
  transform: "translate(0 -97)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "c",
  d: "M379.75,395.48l-17.59-46.3-17.6,46.3a6.64,6.64,0,0,0,6.21,9h22.78A6.63,6.63,0,0,0,379.75,395.48Z",
  transform: "translate(0 -97)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "c",
  d: "M385.38,335.91a23.22,23.22,0,1,1-23.22-23.22A23.23,23.23,0,0,1,385.38,335.91Z",
  transform: "translate(0 -97)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "c",
  d: "M371.7,314.75a23.19,23.19,0,0,1-30.7,30.7,23.21,23.21,0,1,0,30.7-30.7Z",
  transform: "translate(0 -97)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "c",
  d: "M370.45,147.13v170a8.3,8.3,0,1,1-16.59,0V139.71Z",
  transform: "translate(0 -97)"
});

function SvgGraduationcap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 318.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _ref2, title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "graduationcap") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduationcap);
export default __webpack_public_path__ + "static/media/graduationcap.973881eb.svg";
export { ForwardRef as ReactComponent };